export const OPTIONS = {
    root: null,
    rootMargin: '-72px 0px 0px 0px',
    threshold: 0,
};
